




































































import { createComponent, ref, onMounted, computed, watch, SetupContext, reactive } from '@vue/composition-api'
import { getFileIcon, formatFileSize } from '@/helpers/common'
import { UNZIP_COMPRESS_STATUS_CODE } from '@/constant'
import {
    unzipOrCompressTaskDelete,
    unzipOrCompressTaskRetry,
    CompressListItem,
    getCompressList,
    cancelCompressOrUnzip,
} from '@/service/public'
import { Message, MessageBox } from '@heytap/cook-ui'

export default createComponent({
    name: 'ZipList',
    props: {
        dialogData: {
            type: Array,
            default: res => {
                return []
            },
        },
        isShowLoad: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, setupContext: SetupContext) {
        const statusMap = {
            1: '压缩中',
            2: '压缩成功',
            3: '失败（不可重试）',
            4: '失败（可重试）',
        }
        const reStart = async (row: CompressListItem) => {
            const res = await unzipOrCompressTaskRetry(row.id)
            if (res.code === 0) {
                getTableData()
            } else {
                Message.error(res.desc || '重试失败')
            }
        }
        const remove = async (row: CompressListItem) => {
            const res = await unzipOrCompressTaskDelete(row.id)
            if (res.code === 0) {
                getTableData()
            } else {
                Message.error(res.desc || '删除失败')
            }
        }
        const cancel = async (row: CompressListItem) => {
            MessageBox.confirm(`确认取消压缩${row.name}吗？`, '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',

            }).then(async () => {
                const res = await cancelCompressOrUnzip(row.id)
                if(res.code === 0) {
                    getTableData()
                }
            }).catch(() => {
                //
            })
        }
        const tableData = ref<CompressListItem[]>([])
        const getTableData = async () => {
            const res = await getCompressList()
            if (res.code === 0) {
                tableData.value = res.data
            } else {
                tableData.value = []
            }
        }
        onMounted(() => {
            getTableData()
        })
        return {
            getTableData,
            tableData,
            getFileIcon,
            formatFileSize,
            reStart,
            remove,
            statusMap,
            UNZIP_COMPRESS_STATUS_CODE,
            cancel,
        }
    },
})
